module.exports = __webpack_public_path__ + "static/media/commerciale-vendita.eb2d6067.jpg";